import dayjs from "dayjs"
import { CastTime } from "../../../@client/Theasoft_DataClasses_Dispo"
import { getFormattedTimePeriod } from "../../../utils/get-formatted-time"
import { useTranslation } from "react-i18next"

export function useRenderCastTime() {
const {t} = useTranslation("app_server")

  return {renderCastTime: (castTime: CastTime) =>castTime.reason === "Task" ?
    `${getFormattedTimePeriod({ start: castTime.time, end: castTime.endTime })} ${castTime.roleName}` :
  `${dayjs(castTime.time).format("LT")} ${
    castTime.reason && t(castTime.reason)
  }`
}
}
